import React, { useContext, useState, useEffect } from "react";
import { Container, Row, Col, Button, Table, Form } from "react-bootstrap";
import "./Create.css";
import Select from "react-select";
import Header from "../../../Header/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { useForm, Controller, useFieldArray, useWatch } from "react-hook-form";
import classNames from "classnames";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ModalSave from "../../../common/ModelSave";
import { useNavigate } from "react-router";
import JoditEditor from "jodit-react";
import { variant_type } from "../../../../utils/common";
import SingleVarient from "../DoubleVarient";
import DoubleVarient from "../DoubleVarient";

function Create() {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    Select2Data,
    usertype,
    IMG_URL,
    postData,
    getDimension,
  } = useContext(Context);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    getValues,
    trigger,
    setValue,
    clearErrors,
    setError,
  } = useForm({
    defaultValues: {
      variants: [{ name: "", price: "", mrp: "", image: "", description: "" }],
      features: [{ name: "", image: "", description: "" }],
      layers: [{ name: "", description: "" }],
    },
  });

  const [layerCount, setLayerCount] = useState();

  const [imagePreview, setImagePreview] = useState(null);
  const [imagePreview1, setImagePreview1] = useState(null);
  const [imagePreview2, setImagePreview2] = useState(null);
  const [imagePreviewsf, setImagePreviewsf] = useState([]);
  const [imagePreviewl, setImagePreviewl] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [layerCountError, setLayerCountError] = useState("");

  const { fields, append, remove } = useFieldArray({
    control,
    name: "variants",
  });

  const {
    fields: featureFields,
    append: featureAppend,
    remove: featureRemove,
  } = useFieldArray({
    control,
    name: "features",
  });

  const { fields: layerFields, append: layerAppend, remove: layerRemove } =
    useFieldArray({
      control,
      name: "layers",
    });

  useEffect(() => {
    if (featureFields.length === 0) {
      featureAppend({
        name: "",
        imageFiles: [],
        imagePreviews: [],
      });
    }
  }, []);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [variantsError, setVariantsError] = useState("");

  useEffect(() => {
    register("variants", {
      validate: (value) => {
        const isValid = value && value.length > 0;
        setVariantsError(isValid ? "" : "At least one variant is required");
        return isValid;
      },
    });
  }, [register]);

  useEffect(() => {
    register("layer_count", {
      validate: (value) => {
        if (value < 0) return "Number of layers cannot be less than 0";
        if (value > 9) return "Number of layers cannot exceed 9";
        return true;
      }
    });
  }, [register]);

  const variantType = watch("variant_type_id");

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {

      // console.log("SUBMIT CALLED", data);

      const DataToSend = new FormData();
      // Basic Text Fields
      DataToSend.append("name", data?.name);
      DataToSend.append("price", data?.price);
      DataToSend.append("mrp", data?.mrp);
      DataToSend.append("description", data?.description);
      DataToSend.append("manufacturer", data?.manufacturer);
      DataToSend.append("specification", data?.specification);
      DataToSend.append("care", data?.care);
      DataToSend.append("delivery", data?.delivery);
      DataToSend.append("warranty", data?.warranty);
      DataToSend.append("tax_percentage", data?.tax_percentage);
      // DataToSend.append("tag", data?.tag);
      DataToSend.append("measurements", data?.measurements);
      DataToSend.append("discount_percentage", data.discount_percentage);

      // Category and Dropdown IDs (Handling react-select .value)
      DataToSend.append("p_category_id", data?.p_category_id?.value);
      DataToSend.append("shape_id", data?.shape_id?.value);
      DataToSend.append("p_sub_category_id", data?.p_sub_category_id?.value);
      DataToSend.append("p_child_category_id", data?.p_child_category_id?.value);
      DataToSend.append("variant_type_id", data?.variant_type_id?.value);
      // DataToSend.append("unit_id", data?.unit_id?.value);
      DataToSend.append("unit_id", data?.unit_id?.value ?? 1);
      DataToSend.append("made_in_id", data?.made_in_id?.value);

      if (data?.brand_id?.value) {
        DataToSend.append("brand_id", data?.brand_id?.value);
      }
      if (data?.soft_type_id?.value) {
        DataToSend.append("soft_type_id", data?.soft_type_id?.value);
      }

      // Main Images and Banners
      if (data.image?.length) {
        DataToSend.append("image", data.image[0]);
      }
      if (data.banner1?.length) {
        DataToSend.append("banner1", data.banner1[0]);
      }
      if (data.banner2?.length) {
        DataToSend.append("banner2", data.banner2[0]);
      }

      if (data.layer_img?.length) {
        DataToSend.append("layer_img", data.layer_img[0]);
      }

      // Status Toggles
      if (data?.preservation_status) {
        DataToSend.append("preservation_status", data?.preservation_status);
      }
      if (data?.advantages_status) {
        DataToSend.append("advantages_status", data?.advantages_status);
      }
      if (data?.composition_status) {
        DataToSend.append("composition_status", data?.composition_status);
      }
      if (data?.description_status) {
        DataToSend.append("description_status", data?.description_status);
      }

      // Multiple Images Gallery
      if (data?.images && data?.images.length > 0) {
        for (let i = 0; i < data.images.length; i++) {
          DataToSend.append("images", data.images[i]);
        }
      }


      // Features handling - SEND IMAGES AS BINARY FILES
      const featuresJsonData = [];
      data.features.forEach((f, idx) => {
        featuresJsonData.push({
          name: f.name ?? null,
          description: f.description ?? null,
          count: data.features?.length || 0,
        });

        if (f.image instanceof File) {
          DataToSend.append(`feature_image_${idx}`, f.image);
        }
      });

      DataToSend.append("features", JSON.stringify(featuresJsonData));

      const layersJsonData = [];
      data.layers.forEach((f, idx) => {
        layersJsonData.push({
          name: f.name ?? null,
          description: f.description ?? null,
          sr_no: f.sr_no ?? null,
        });
      });

      // DataToSend.append("layers", JSON.stringify(layersJsonData));
      const validLayers =
        data.layers
          ?.filter((l) => l.name || l.description) // remove empty rows
          ?.map((l, idx) => ({
            name: l.name,
            description: l.description,
            sr_no: idx + 1,
          })) || [];

      //  DO NOT SEND ANYTHING if zero layers exist
      if (validLayers.length > 0) {
        DataToSend.append("layers", JSON.stringify(validLayers));
      }



      // Nested Variants Logic (Single -> Double -> Triple)

      const variants = [];
      if (data.variants && data.variants.length > 0) {
        data.variants.forEach((variant) => {
          const singleVariant = {
            // name: variant?.name ?? null,
            price: variant?.price ?? null,
            mrp: variant?.mrp ?? null,
            metal_id: variant?.metal_id ?? null,
            description: variant?.description ?? null,
            double_variants: [],
          };

          if (Array.isArray(variant?.double_variants)) {
            variant.double_variants.forEach((doubleVal) => {
              const doubleVariant = {
                // name: variant?.name ?? null,
                mrp: doubleVal?.mrp ?? null,
                price: doubleVal?.price ?? null,
                size_id: doubleVal?.size_id ?? null,
                triple_variants: [],
              };

              if (Array.isArray(doubleVal?.triple_variants)) {
                doubleVal.triple_variants.forEach((tripleVal) => {
                  doubleVariant.triple_variants.push({
                    // name: variant?.name ?? null,
                    mrp: tripleVal?.mrp ?? null,
                    price: tripleVal?.price ?? null,
                    diamond_id: tripleVal?.diamond_id ?? null,
                  });
                });
              }
              singleVariant.double_variants.push(doubleVariant);
            });
          }
          variants.push(singleVariant);
        });
      }
      DataToSend.append("variants", JSON.stringify(variants));
      console.log("----- FORM DATA DEBUG START -----");
      for (let p of DataToSend.entries()) {
        console.log(p[0], p[1]);
      }
      console.log("----- FORM DATA DEBUG END -----");
      // API Call
      const response = await postData("/admin/products", DataToSend);

      if (response?.success) {
        setShowModal({ code: response.code, message: response.message });
        setTimeout(() => {
          reset();
          setShowModal({ code: 0, message: "" });
          navigate("/products");
        }, 1500);
      } else {
        setShowModal({
          code: response?.code || 500, message: response?.message || "Something went wrong"
        });
        setTimeout(() => {
          reset();
          setShowModal({ code: 0, message: "" });
          navigate("/products");
        }, 1500);
      }
    } catch (error) {
      console.error("Critical Submission Error:", error);
    }
    finally {
      setIsLoading(false); // 👈 Stop loading (success or error)
    }
  };


  const [Countries, setCountries] = useState([]);

  const [brands, setBrands] = useState([]);
  const [units, setUnits] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [childCategories, setChildCategories] = useState([]);
  const [softType, setSoftType] = useState([]);
  const [VarientType, setVarientType] = useState([]);
  const [DeliveryType, setDeliveryType] = useState([]);

  const [shapes, setShape] = useState([]);

  const getAllBrands = async () => {
    const response = await getData(`/common/masters/all-brands`);
    if (response?.success) {
      setBrands(await Select2Data(response?.data, "brand_id"));
    }
  };

  const getAllShapes = async () => {
    const response = await getData(`/common/masters/all-shape`);
    if (response?.success) {
      setShape(await Select2Data(response?.data, "shape_id"));
    }
  };
  const getAllUnits = async () => {
    const response = await getData(`/common/masters/all-units`);
    if (response?.success) {
      setUnits(await Select2Data(response?.data, "unit_id"));
    }
  };
  const getAllCategories = async () => {
    const response = await getData("/common/masters/all-p-category");
    if (response?.success) {
      setCategories(await Select2Data(response?.data, "p_category_id"));
    }
  };
  const getAllSubCategories = async (id) => {
    const response = await getData(
      `/common/masters/all-vendor-p-sub-categories/${id}`,
    );
    if (response?.success) {
      setSubCategories(await Select2Data(response?.data, "p_sub_category_id"));
    }
  };

  const getAllChildCategories = async (id) => {
    const response = await getData(
      `/common/masters/all-p-child-category/${id}`,
    );
    if (response?.success) {
      setChildCategories(
        await Select2Data(response?.data, "p_child_category_id"),
      );
    }
  };
  const getAllCountries = async () => {
    const response = await getData(`/common/masters/all-country`);
    if (response?.success) {
      setCountries(await Select2Data(response?.data, "made_in_id"));
    }
  };
  const getAllVarientType = async () => {
    const response = await getData(`/common/masters/all-variant-type`);
    if (response?.success) {
      setVarientType(await Select2Data(response?.data, "stock_type_id"));
    }
  };

  const getAllDeliveryType = async () => {
    const response = await getData(`/common/masters//all-delivery-type`);
    if (response?.success) {
      setDeliveryType(await Select2Data(response?.data, "farmer_id"));
    }
  };

  const getAllSoftType = async () => {
    const response = await getData(`/common/masters/all-soft-type`);
    if (response?.success) {
      setSoftType(await Select2Data(response?.data, "soft_type_id"));
    }
  };
  useEffect(() => {
    getAllCountries();
    getAllBrands();
    getAllUnits();
    getAllCategories();
    getAllVarientType();
    getAllDeliveryType();
    getAllShapes();
    getAllSoftType();
  }, []);

  // State to store image preview

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };
  const handleImageChange1 = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview1(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };
  const handleImageChange2 = (e) => {
    const file = e.target.files[0];

    if (!file) {
      e.target.value = '';
      return;
    }

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview2(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const handleImageChangel = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviewl(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const [imagePreviews, setImagePreviews] = useState([]);



  const handleImagesChange = (e) => {
    const files = e.target.files;
    if (files) {
      const previews = [];
      Array.from(files).forEach((file) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          previews.push(reader.result);
          if (previews.length === files.length) {
            setImagePreviews(previews);
          }
        };
        reader.readAsDataURL(file);
      });
    }
  };

  // const handleImagesChangef = (e) => {
  //   const files = e.target.files;
  //   if (files) {
  //     const previews = [];
  //     Array.from(files).forEach((file) => {
  //       const reader = new FileReader();
  //       reader.onloadend = () => {
  //         previews.push(reader.result);
  //         if (previews.length === files.length) {
  //           setImagePreviewsf(previews);
  //         }
  //       };
  //       reader.readAsDataURL(file);
  //     });
  //   }
  // };

  const handleImagesChangef = (e, index, setValue) => {
    const file = e.target.files?.[0];

    if (!file) return;

    // 1. set RHF value (VERY IMPORTANT)
    setValue(`features.${index}.image`, file);

    // 2. preview
    const preview = URL.createObjectURL(file);

    setImagePreviewsf((prev) => {
      const updated = [...prev];
      updated[index] = [preview];
      return updated;
    });
  };

  //discount price

  // const PriceAutoCalculator = ({ index, control, setValue }) => {
  //   const mrp = useWatch({
  //     control,
  //     name: `variants.${index}.mrp`,
  //   });
  //   const discount = useWatch({
  //     control,
  //     name: `discount_percentage`,
  //   });
  //   useEffect(() => {
  //     // console.log("Index:", index);
  //     // console.log("MRP:", mrp);
  //     // console.log("Discount:", discount);

  //     const mrpNum = parseFloat(mrp);
  //     const discountNum = parseFloat(discount);

  //     if (!mrpNum) {
  //       setValue(`variants.${index}.price`, "");
  //       return;
  //     }

  //     if (discount === "" || discount === undefined || discount === null) {
  //       setValue(`variants.${index}.price`, mrpNum.toFixed(2));
  //       return;
  //     }

  //     const price = mrpNum - (mrpNum * discountNum) / 100;

  //     setValue(`variants.${index}.price`, price.toFixed(2));
  //   }, [mrp, discount, index, setValue]);

  //   return null;
  // };

  const PriceAutoCalculator = ({ index, control, setValue, getValues }) => {
    // Watch both values
    const mrp = useWatch({
      control,
      name: `variants.${index}.mrp`,
      defaultValue: "",
    });

    const discount = useWatch({
      control,
      name: "discount_percentage",
      defaultValue: "",
    });

    // Force recalculation when either value changes
    useEffect(() => {

      // Clear timeout if exists
      let timeoutId;

      const calculatePrice = () => {
        const mrpNum = parseFloat(mrp);
        const discountNum = parseFloat(discount);


        if (!mrpNum || isNaN(mrpNum)) {
          setValue(`variants.${index}.price`, "", { shouldValidate: false });
          return;
        }

        if (!discountNum || isNaN(discountNum) || discount === "" || discount === null) {
          setValue(`variants.${index}.price`, mrpNum.toFixed(2), { shouldValidate: false });
          return;
        }

        const price = mrpNum - (mrpNum * discountNum) / 100;
        const formattedPrice = price.toFixed(2);

        setValue(`variants.${index}.price`, formattedPrice, { shouldValidate: false });
      };

      // Use timeout to avoid race conditions
      timeoutId = setTimeout(calculatePrice, 0);

      return () => {
        if (timeoutId) clearTimeout(timeoutId);
      };
    }, [mrp, discount, index, setValue]);

    return null;
  };

  const refreshAllVariantPrices = () => {
    const discount = getValues("discount_percentage");
    const discountNum = parseFloat(discount);

    fields.forEach((_, index) => {
      const mrp = getValues(`variants.${index}.mrp`);
      const mrpNum = parseFloat(mrp);

      if (mrpNum && !isNaN(mrpNum)) {
        if (discountNum && !isNaN(discountNum)) {
          const price = mrpNum - (mrpNum * discountNum) / 100;
          setValue(`variants.${index}.price`, price.toFixed(2));
        } else {
          setValue(`variants.${index}.price`, mrpNum.toFixed(2));
        }
      } else {
        setValue(`variants.${index}.price`, "");
      }
    });
  };


  const handleLayerCountChange = (count) => {
    // Allow empty string (user is typing)
    if (count === "") {
      setLayerCount("");
      setLayerCountError("");
      return;
    }

    const parsedCount = parseInt(count);

    // Check if it's a valid number
    if (isNaN(parsedCount)) {
      setLayerCountError("Please enter a valid number");
      setLayerCount(count);
      return;
    }

    // Check if outside valid range
    if (parsedCount < 0) {
      setLayerCountError("Number of layers cannot be less than 0");
      setLayerCount(parsedCount);
      return;
    }

    if (parsedCount > 9) {
      setLayerCountError("Number of layers cannot exceed 9");
      setLayerCount(parsedCount);
      return;
    }

    // Clear error if validation passes
    setLayerCountError("");
    setLayerCount(parsedCount);

    // Only update layers if count is between 1-9
    if (parsedCount >= 1 && parsedCount <= 9) {
      let layers = getValues("layers") || [];

      if (parsedCount > layers.length) {
        for (let i = layers.length; i < parsedCount; i++) {
          layers.push({
            name: "",
            description: "",
          });
        }
      }

      if (parsedCount < layers.length) {
        layers = layers.slice(0, parsedCount);
      }

      setValue("layers", layers);
    } else if (parsedCount === 0) {
      setValue("layers", []);
    }
  };

  const [videoPreview, setVideoPreview] = useState(null);
  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setVideoPreview(previewUrl);
    }
  };

  const [Metals, setMetal] = useState([]);
  const getAllMetal = async () => {
    const response = await getData(`/common/masters/all-metal`);
    if (response?.success) {
      setMetal(await Select2Data(response?.data, "metal_id"));
    }
  };

  const [Sizes, setSize] = useState([]);
  const getAllSize = async () => {
    const response = await getData(`/common/masters/all-size`);
    if (response?.success) {
      setSize(await Select2Data(response?.data, "size_id"));
    }
  };

  const [Diamonds, setDiamond] = useState([]);
  const getAllDiamond = async () => {
    const response = await getData(`/common/masters/all-diamond`);
    if (response?.success) {
      setDiamond(await Select2Data(response?.data, "diamond_id"));
    }
  };

  useEffect(() => {
    getAllSize();
    getAllDiamond();
    getAllMetal();
  }, []);

  const watchedLayers = watch("layers");



  return (
    <>
      <Header title={"Create Product"} link={"/employee/employee_details"} />
      <section className="Create">
        {/* back button start */}
        <div className="back_btn_holder d-flex ">
          <div onClick={() => navigate(`/products`)}>
            <FontAwesomeIcon className="back-btn" icon={faAngleLeft} />
            Back
          </div>
        </div>
        {/* back button end */}

        <Form onSubmit={handleSubmit(onSubmit)}>
          {/* 1. Order Details start */}
          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>1. Product Category</h6>
            </div>
            <div className="package-details-section">
              <div className="pending-table ">
                <div className="row  align-items-start">
                  <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12">
                    <Form.Label>Category</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`p_category_id`} // name of the field
                      control={control}
                      rules={{
                        required: "Select Category",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          placeholder="Select Category"
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.p_category_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={categories}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                            getAllSubCategories(selectedValue?.value);
                            setValue("p_sub_category_id", "");
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.p_category_id && (
                      <span className="text-danger">
                        {errors.p_category_id.message}
                      </span>
                    )}
                  </div>

                  <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12">
                    <Form.Label>Sub Category</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`p_sub_category_id`} // name of the field
                      control={control}
                      rules={{
                        required: "Select Sub Category",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                            placeholder="Select Sub Category"
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.p_sub_category_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={subCategories}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                            getAllChildCategories(selectedValue?.value);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.p_sub_category_id && (
                      <span className="text-danger">
                        {errors.p_sub_category_id.message}
                      </span>
                    )}
                  </div>

                  <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12">
                    <Form.Label>Child Category</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`p_child_category_id`} // name of the field
                      control={control}
                      rules={{
                        required: "Select Child Category",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                            placeholder="Select Child Category"
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.p_child_category_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={childCategories}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.p_child_category_id && (
                      <span className="text-danger">
                        {errors.p_child_category_id.message}
                      </span>
                    )}
                  </div>

                  <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12">
                    <Form.Label>Brand</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`brand_id`} // name of the field
                      control={control}
                       rules={{
                        required: "Select Brand",
                      }}
                     
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                            placeholder="Select Brand"
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.brand_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={brands}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.brand_id && (
                      <span className="text-danger">
                        {errors.brand_id.message}
                      </span>
                    )}
                  </div>

                  <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12">
                    <Form.Label>Soft Type</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`soft_type_id`} // name of the field
                      control={control}
                       rules={{
                        required: "Select Soft Type",
                      }}
                     
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select

                              placeholder="Select Soft Type"
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.soft_type_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={softType}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.soft_type_id && (
                      <span className="text-danger">
                        {errors.soft_type_id.message}
                      </span>
                    )}
                  </div>
                  <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12">
                    <Form.Label>Material</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`shape_id`} // name of the field
                      control={control}
                      rules={{
                        required: "Select Material",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select

                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.shape_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={shapes}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.shape_id && (
                      <span className="text-danger">
                        {errors.shape_id.message}
                      </span>
                    )}
                  </div>

                  <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12">
                    <Form.Label>Made In</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`made_in_id`} // name of the field
                      control={control}
                      rules={{
                        required: "Select Product",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                            placeholder="Select Country"
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.made_in_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={Countries}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.made_in_id && (
                      <span className="text-danger">
                        {errors.made_in_id.message}
                      </span>
                    )}
                  </div>
                  {/* 
                  <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12">
                    <Form.Label>Expiry Date Alert Days</Form.Label>
                    <Form.Control
                      type="text"
                      name="expity_date_days"
                      placeholder="Expiry Date Alert Days"
                      className={classNames("", {
                        "is-invalid": errors?.expity_date_days,
                      })}
                      {...register("expity_date_days", {
                        required: "Expiry Date Alert Days is required",
                      })}
                      onKeyDown={(e) => {
                        // Allow: Backspace, Tab, Arrow keys, Delete
                        if (
                          [
                            "Backspace",
                            "Tab",
                            "ArrowLeft",
                            "ArrowRight",
                            "Delete",
                          ].includes(e.key)
                        ) {
                          return;
                        }

                        // Prevent non-numeric keys
                        if (!/^[0-9]$/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />

                    {errors.expity_date_days && (
                      <span className="text-danger">
                        {errors.expity_date_days.message}
                      </span>
                    )}
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>2. Product</h6>
            </div>
            <div className="package-details-section">
              {/* Package Weight */}
              <Row className="detail-row">
                <Col md={4}>
                  <div className="detail-label">Name</div>
                </Col>
                <Col lg={4} md={4}>
                  <div className="">
                    <Form.Control
                      type="text"
                      name={`name`}
                      placeholder="name"
                      className={classNames("", {
                        "is-invalid": errors?.name,
                      })}
                      {...register(`name`, {
                        required: "name is required",
                        validate: (value) => {
                          const words = value.match(/\b\w+\b/g);
                          return (
                            !words ||
                            words.length <= 50 ||
                            "Data must be 100 words or less"
                          );
                        },
                      })}
                    />
                  </div>
                  {errors.name && (
                    <span className="text-danger">{errors.name.message}</span>
                  )}
                </Col>
              </Row>

              <Row className="detail-row">
                <Col md={4}>
                  <div className="detail-label">
                    Thumbnail Upload image (928 × 945 px).
                  </div>
                </Col>
                <Col lg={4} md={4}>
                  <div className="">
                    <Form.Control
                      type="file"
                      name="image"
                      placeholder="Image"
                      className={classNames("", {
                        "is-invalid": errors?.image,
                      })}
                      {...register("image", {
                        required: "Image is required",
                        // validate: async (value) => {
                        //   if (typeof value !== "string") {
                        //     const fileTypes = ["jpg", "png", "jpeg", "webp"];
                        //     const fileType = value[0].name?.split(".")[1];

                        //     if (!fileTypes.includes(fileType)) {
                        //       return `please upload a valid file format. (${fileTypes})`;
                        //     }
                        //     const sizes = await getDimension(value[0]);
                        //     // if (sizes.width !== 928 && sizes.height !== 945) {
                        //     //   return "Image width and height must be 928 px and 945 px";
                        //     // }
                        //     const fileSize = Math.round(value[0].size / 1024);
                        //     if (fileSize > 500) {
                        //       return "file size must be lower than 500kb";
                        //     }
                        //   }
                        // },
                      })}
                      accept="image/*, video/*"
                      onChange={handleImageChange}
                    />
                  </div>
                  {errors.image && (
                    <span className="text-danger">{errors.image.message}</span>
                  )}
                </Col>
                <Col lg={4} md={4}>
                  {imagePreview && (
                    <div className="Preview_img_holder">
                      {/* Check if the preview is an image or video */}
                      {imagePreview.includes("video") ? (
                        // Display video preview if it's a video
                        <video
                          className="Preview_video"
                          autoPlay
                          muted
                          loop
                          // controls
                          style={{ maxWidth: "300px" }}
                        >
                          <source src={imagePreview} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      ) : (
                        // Display image preview if it's an image
                        <img
                          className="Preview_img"
                          src={imagePreview}
                          alt="Thumbnail Image Preview"
                          style={{ maxWidth: "300px" }}
                        />
                      )}
                    </div>
                  )}
                </Col>
              </Row>

              <Row className="detail-row">
                <Col md={4}>
                  <div className="detail-label">
                    Banner 1 (928 × 945 px).
                  </div>
                </Col>
                <Col lg={4} md={4}>
                  <div className="">
                    <Form.Control
                      type="file"
                      name="banner1"
                      placeholder="Image"
                      className={classNames("", {
                        "is-invalid": errors?.banner1,
                      })}
                      {...register("banner1", {
                        required: "Image is required",

                      })}
                      accept="image/*, video/*"
                      onChange={handleImageChange1}
                    />
                  </div>
                  {errors.banner1 && (
                    <span className="text-danger">{errors.banner1.message}</span>
                  )}
                </Col>
                <Col lg={4} md={4}>
                  {imagePreview1 && (
                    <div className="Preview_img_holder">
                      {/* Check if the preview is an image or video */}
                      {imagePreview1.includes("video") ? (
                        // Display video preview if it's a video
                        <video
                          className="Preview_video"
                          autoPlay
                          muted
                          loop
                          // controls
                          style={{ maxWidth: "300px" }}
                        >
                          <source src={imagePreview1} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      ) : (
                        // Display image preview if it's an image
                        <img
                          className="Preview_img"
                          src={imagePreview1}
                          alt="Banner 1 Preview"
                          style={{ maxWidth: "300px" }}
                        />
                      )}
                    </div>
                  )}
                </Col>
              </Row>

              <Row className="detail-row">
                <Col md={4}>
                  <div className="detail-label">
                    Banner 2 (928 × 945 px).
                  </div>
                </Col>
                <Col lg={4} md={4}>
                  <div className="">
                    <Form.Control
                      type="file"
                      name="banner2"
                      placeholder="Image"
                      className={classNames("", {
                        "is-invalid": errors?.banner2,
                      })}
                      {...register("banner2", {
                        required: "Image is required",

                      })}
                      accept="image/*, video/*"
                      onChange={handleImageChange2}
                    />
                  </div>
                  {errors.banner2 && (
                    <span className="text-danger">{errors.banner2.message}</span>
                  )}
                </Col>
                <Col lg={4} md={4}>
                  {imagePreview2 && (
                    <div className="Preview_img_holder">
                      {/* Check if the preview is an image or video */}
                      {imagePreview2.includes("video") ? (
                        // Display video preview if it's a video
                        <video
                          className="Preview_video"
                          autoPlay
                          muted
                          loop
                          // controls
                          style={{ maxWidth: "300px" }}
                        >
                          <source src={imagePreview2} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      ) : (
                        // Display image preview if it's an image
                        <img
                          className="Preview_img"
                          src={imagePreview2}
                          alt="Banner 2 Preview"
                          style={{ maxWidth: "300px" }}
                        />
                      )}
                    </div>
                  )}
                </Col>
              </Row>


              <Row className="detail-row">
                <Col md={4}>
                  <div className="detail-label">
                    Layer Img
                  </div>
                </Col>
                <Col lg={4} md={4}>
                  <div className="">
                    <Form.Control
                      type="file"
                      name="layer_img"
                      placeholder=" Layer Image"
                      className={classNames("", {
                        "is-invalid": errors?.layer_img,
                      })}
                      {...register("layer_img", {
                        required: "Image is required",

                      })}
                      accept="image/*, video/*"
                      onChange={handleImageChangel}
                    />
                  </div>
                  {errors.layer_img && (
                    <span className="text-danger">{errors.layer_img.message}</span>
                  )}
                </Col>

                <Col lg={4} md={4}>
                  {imagePreviewl && imagePreviewl.includes("video") ? (
                    <div className="Preview_img_holder">
                      <video
                        className="Preview_video"
                        autoPlay
                        muted
                        loop
                        style={{ maxWidth: "300px" }}
                      >
                        <source src={imagePreviewl} type="video/mp4" />
                      </video>
                    </div>
                  ) : imagePreviewl && imagePreviewl.includes("image") ? (
                    <div className="Preview_img_holder">
                      <img
                        className="Preview_img"
                        src={imagePreviewl}
                        alt="" // Empty alt for decorative images
                        style={{ maxWidth: "300px" }}
                      />
                    </div>
                  ) : null}
                </Col>

              </Row>

              {/* <Row className="detail-row">
                <Col md={4}>
                  <div className="detail-label">
                    Video Upload (MP4 / WebM / OGG – Max 10MB)
                  </div>
                </Col>

                <Col lg={4} md={4}>
                  <Form.Control
                    type="file"
                    name="video"
                    className={classNames("", {
                      "is-invalid": errors?.video,
                    })}
                    accept="video/mp4,video/webm,video/ogg"
                    {...register("video", {
                      required: "Video is required",
                      validate: (value) => {
                        if (!value || !value.length) return true;

                        const file = value[0];
                        const allowedTypes = [
                          "video/mp4",
                          "video/webm",
                          "video/ogg",
                        ];

                        // ✔ Validate video type
                        if (!allowedTypes.includes(file.type)) {
                          return "Only MP4, WebM, or OGG video formats are allowed";
                        }

                        // ✔ Validate file size (10MB max)
                        // const fileSizeMB = file.size / (1024 * 1024);
                        // if (fileSizeMB > 10) {
                        //   return "Video size must be less than 10MB";
                        // }

                        return true;
                      },
                    })}
                    onChange={handleVideoChange}
                  />

                  {errors.video && (
                    <span className="text-danger">{errors.video.message}</span>
                  )}
                </Col>

                <Col lg={4} md={4}>
                  {videoPreview && (
                    <div className="Preview_img_holder">
                      <video
                        className="Preview_video"
                        controls
                        muted
                        style={{ maxWidth: "300px" }}
                      >
                        <source src={videoPreview} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  )}
                </Col>
              </Row> */}

              <Row className="detail-row">

                {/* <Col md={4}>
                  <div className="detail-label">Unit</div>
                </Col>

                <Col lg={4} md={4}>
                  <div className=" ">
                    <Controller
                      className="select-contoller "
                      name={`unit_id`} // name of the field
                      control={control}
                      rules={{
                        required: "Select Unit",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                              placeholder="Select Unit"
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.unit_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={units}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                  </div>
                  {errors.unit_id && (
                    <span className="text-danger">
                      {errors.unit_id.message}
                    </span>
                  )}
                </Col> */}

              </Row>
            </div>
          </div>

          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>3. Details</h6>
            </div>

            <div className="package-details-section">

              <Row className="detail-row">

                <Col md={4}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>Tax Percentage</Form.Label>
                      <Form.Group>
                        <Form.Control
                          type="text"
                          name={`tax_percentage`}
                          placeholder="Tax Percentage (%)"
                          className={classNames("", {
                            "is-invalid": errors?.tax_percentage, // Adjusted error checking
                          })}
                          {...register(`tax_percentage`, {
                            required: "Tax Percentage is required",
                            validate: (value) => {
                              const numericValue = parseFloat(value);
                              if (numericValue > 100) {
                                return "Tax percentage cannot exceed 100";
                              }
                              return true;
                            },
                          })}
                          onKeyDown={(e) => {
                            // Allow numbers, backspace, left arrow, right arrow, and a decimal point
                            if (
                              !/[0-9]/.test(e.key) && // Disallow any non-numeric key
                              e.key !== "Backspace" &&
                              e.key !== "ArrowLeft" &&
                              e.key !== "ArrowRight" &&
                              e.key !== "."
                            ) {
                              e.preventDefault(); // Prevent the event if it's not allowed
                            }

                            // Prevent entering more than one decimal point
                            if (e.key === "." && e.target.value.includes(".")) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            // Ensure the value stays within the range of 0 to 100
                            const value = e.target.value;
                            if (parseFloat(value) > 100) {
                              e.target.value = "100"; // Set the value to 100 if it exceeds
                            }
                          }}
                        />
                        {errors.tax_percentage && (
                          <span className="text-danger">
                            {errors.tax_percentage.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>Manufacturer</Form.Label>
                      <Form.Group>
                        <Form.Control
                          type="text"
                          name={`manufacturer`}
                          placeholder="manufacturer"
                          className={classNames("", {
                            "is-invalid": errors?.manufacturer, // Adjusted error checking
                          })}
                          {...register(`manufacturer`, {
                            required: "manufacturer is required",
                          })}
                        />
                        {errors.manufacturer && (
                          <span className="text-danger">
                            {errors.manufacturer.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
              </Row>

              <Row className="detail-row">
                {/* <Col md={4}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>License No</Form.Label>
                      <Form.Group>
                        <Form.Control
                          type="text"
                          name={`lic_no`}
                          placeholder="License No"
                          className={classNames("", {
                            "is-invalid": errors?.lic_no, // Adjusted error checking
                          })}
                          {...register(`lic_no`, {
                            // required: "License No is required",
                          })}
                        />
                        {errors.lic_no && (
                          <span className="text-danger">
                            {errors.lic_no.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col> */}


                {/* <Col md={4}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>Tag</Form.Label>
                      <Form.Group>
                        <Form.Control
                          type="text"
                          name={`tag`}
                          placeholder="Tag"
                          className={classNames("", {
                            "is-invalid": errors?.tag, // Adjusted error checking
                          })}
                          {...register(`tag`, {
                            // required: "License No is required",
                          })}
                        />
                        {errors.tag && (
                          <span className="text-danger">
                            {errors.tag.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col> */}


                <Col md={4}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>Discount Percentage</Form.Label>
                      <Form.Group>
                        <Form.Control
                          type="text"
                          name={`discount_percentage`}
                          placeholder="Discount Percentage (%)"
                          className={classNames("", {
                            "is-invalid": errors?.discount_percentage, // Adjusted error checking
                          })}
                          {...register(`discount_percentage`, {
                            required: "discount Percentage is required",
                            validate: (value) => {
                              const numericValue = parseFloat(value);
                              if (numericValue > 100) {
                                return "discount percentage cannot exceed 100";
                              }
                              return true;
                            },

                            onBlur: (e) => {
                              refreshAllVariantPrices();
                            }
                          })}
                          onKeyDown={(e) => {
                            // Allow numbers, backspace, left arrow, right arrow, and a decimal point
                            if (
                              !/[0-9]/.test(e.key) && // Disallow any non-numeric key
                              e.key !== "Backspace" &&
                              e.key !== "ArrowLeft" &&
                              e.key !== "ArrowRight" &&
                              e.key !== "."
                            ) {
                              e.preventDefault(); // Prevent the event if it's not allowed
                            }

                            // Prevent entering more than one decimal point
                            if (e.key === "." && e.target.value.includes(".")) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            refreshAllVariantPrices();
                            // Ensure the value stays within the range of 0 to 100
                            const value = e.target.value;
                            if (parseFloat(value) > 100) {
                              e.target.value = "100"; // Set the value to 100 if it exceeds
                            }
                          }}
                        />
                        {errors.discount_percentage && (
                          <span className="text-danger">
                            {errors.discount_percentage.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>

                {/* <Col md={4}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>Measurements</Form.Label>
                      <Form.Group>
                        <Form.Control
                          type="text"
                          name={`measurements`}
                          placeholder="measurements"
                          className={classNames("", {
                            "is-invalid": errors?.measurements, // Adjusted error checking
                          })}
                          {...register(`measurements`, {
                            // required: "License No is required",
                          })}
                        />
                        {errors.measurements && (
                          <span className="text-danger">
                            {errors.measurements.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col> */}
              </Row>

              <Row className="detail-row">

                <Col md={12}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>
                        Description{" "}
                        {/* <Form.Check
                          type="switch"
                          id="description_status" // Give it an id for accessibility
                          label=""
                          name="description_status"
                          checked={watch("description_status")} // Assuming you're using react-hook-form to track state
                          onChange={(e) => {
                            setValue("description_status", e.target.checked);
                          }} // Update form state on toggle
                          className={classNames("", {
                            "is-invalid": errors?.description_status,
                          })}
                        /> */}
                      </Form.Label>
                      <Form.Group>
                        <Controller
                          name="description"
                          control={control}
                          rules={{
                            validate: (value) => {
                              const clean = value?.replace(/<[^>]+>/g, "").trim();
                              return clean?.length > 0 || "description is required.";
                            }
                          }}
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              onBlur={() => {
                                onBlur();
                                trigger("description");
                              }}
                              onChange={onChange}
                            />
                          )}
                        />
                        {errors.description && (
                          <span className="text-danger">
                            {errors.description.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>

              </Row>
              {/* <Row className="detail-row">
                <Col md={12}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>
                        Features{" "}
                        <Form.Check
                          type="switch"
                          id="advantages_status" // Give it an id for accessibility
                          label=""
                          name="advantages_status"
                          checked={watch("advantages_status")} // Assuming you're using react-hook-form to track state
                          onChange={(e) => {
                            setValue("advantages_status", e.target.checked);
                          }} // Update form state on toggle
                          className={classNames("", {
                            "is-invalid": errors?.advantages_status,
                          })}
                        />
                      </Form.Label>
                      <Form.Group>
                        <Controller
                          name="features"
                          control={control}
                          rules={{
                            required: "features is required.",
                            // maxLength: {
                            //   value: 600,
                            //   message:
                            //     "content must be at most 600 characters long.",
                            // },
                          }} // Correct the maxLength rule
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              onBlur={() => {
                                onBlur();
                                trigger("features");
                              }}
                              onChange={onChange}
                            />
                          )}
                        />
                        {errors.features && (
                          <span className="text-danger">
                            {errors.features.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
              </Row>
              <Row className="detail-row">
                <Col md={12}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>
                        Specifications{" "}
                        <Form.Check
                          type="switch"
                          id="preservation_status" // Give it an id for accessibility
                          label=""
                          name="preservation_status"
                          checked={watch("preservation_status")} // Assuming you're using react-hook-form to track state
                          onChange={(e) => {
                            setValue("preservation_status", e.target.checked);
                          }} // Update form state on toggle
                          className={classNames("", {
                            "is-invalid": errors?.preservation_status,
                          })}
                        />
                      </Form.Label>
                      <Form.Group>
                        <Controller
                          name="specification"
                          control={control}
                          rules={{
                            required: "specification is required.",
                            // maxLength: {
                            //   value: 600,
                            //   message:
                            //     "content must be at most 600 characters long.",
                            // },
                          }} // Correct the maxLength rule
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              onBlur={() => {
                                onBlur();
                                trigger("specification");
                              }}
                              onChange={onChange}
                            />
                          )}
                        />
                        {errors.specification && (
                          <span className="text-danger">
                            {errors.specification.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
              </Row>
              <Row className="detail-row">
                <Col md={12}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>
                        Care{" "}
                        <Form.Check
                          type="switch"
                          id="composition_status" // Give it an id for accessibility
                          label=""
                          name="composition_status"
                          checked={watch("composition_status")} // Assuming you're using react-hook-form to track state
                          onChange={(e) => {
                            setValue("composition_status", e.target.checked);
                          }} // Update form state on toggle
                          className={classNames("", {
                            "is-invalid": errors?.composition_status,
                          })}
                        />
                      </Form.Label>
                      <Form.Group>
                        <Controller
                          name="care"
                          control={control}
                          rules={{
                            required: "care is required.",
                            // maxLength: {
                            //   value: 600,
                            //   message:
                            //     "content must be at most 600 characters long.",
                            // },
                          }} // Correct the maxLength rule
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              onBlur={() => {
                                onBlur();
                                trigger("care");
                              }}
                              onChange={onChange}
                            />
                          )}
                        />
                        {errors.care && (
                          <span className="text-danger">
                            {errors.care.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
              </Row>
              <Row className="detail-row">
                <Col md={12}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>
                        Delivery{" "}
                        <Form.Check
                          type="switch"
                          id="composition_status" // Give it an id for accessibility
                          label=""
                          name="composition_status"
                          checked={watch("composition_status")} // Assuming you're using react-hook-form to track state
                          onChange={(e) => {
                            setValue("composition_status", e.target.checked);
                          }} // Update form state on toggle
                          className={classNames("", {
                            "is-invalid": errors?.composition_status,
                          })}
                        />
                      </Form.Label>
                      <Form.Group>
                        <Controller
                          name="delivery"
                          control={control}
                          rules={{
                            required: "delivery is required.",
                            // maxLength: {
                            //   value: 600,
                            //   message:
                            //     "content must be at most 600 characters long.",
                            // },
                          }} // Correct the maxLength rule
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              onBlur={() => {
                                onBlur();
                                trigger("delivery");
                              }}
                              onChange={onChange}
                            />
                          )}
                        />
                        {errors.delivery && (
                          <span className="text-danger">
                            {errors.delivery.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
              </Row>
              <Row className="detail-row">
                <Col md={12}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>
                        Warranty{" "}
                        <Form.Check
                          type="switch"
                          id="composition_status" // Give it an id for accessibility
                          label=""
                          name="composition_status"
                          checked={watch("composition_status")} // Assuming you're using react-hook-form to track state
                          onChange={(e) => {
                            setValue("composition_status", e.target.checked);
                          }} // Update form state on toggle
                          className={classNames("", {
                            "is-invalid": errors?.composition_status,
                          })}
                        />
                      </Form.Label>
                      <Form.Group>
                        <Controller
                          name="warranty"
                          control={control}
                          rules={{
                            required: "warranty is required.",
                            // maxLength: {
                            //   value: 600,
                            //   message:
                            //     "content must be at most 600 characters long.",
                            // },
                          }} // Correct the maxLength rule
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              onBlur={() => {
                                onBlur();
                                trigger("warranty");
                              }}
                              onChange={onChange}
                            />
                          )}
                        />
                        {errors.warranty && (
                          <span className="text-danger">
                            {errors.warranty.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
              </Row> */}
            </div>
          </div>

          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>Features</h6>
            </div>

            <div className="package-details-section">
              {featureFields?.map((features, index) => (
                <div key={features.id} className="main-form-section mt-3">
                  <Row className="">
                    <Col md={4}>
                      <div className="main-form-section mb-3">
                        <Form.Group>
                          <div className="">
                            <Form.Label>Name</Form.Label>
                          </div>

                          <Controller
                            className="select-contoller"
                            name={`features.${index}.name`}
                            control={control}
                            rules={{
                              required: "Enter Name",
                            }}
                            render={({
                              field: { onChange, onBlur, value, ref },
                            }) => (
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter name"
                                onChange={(e) => onChange(e.target.value)}
                                onBlur={onBlur}
                                value={value || ""}
                                ref={ref}
                                style={{
                                  borderColor: errors?.features?.[index]
                                    ?.name
                                    ? "red"
                                    : undefined,
                                }}
                              />
                            )}
                          />

                          {errors?.features?.[index]?.name && (
                            <span className="text-danger">
                              {errors?.features?.[index]?.name.message}
                            </span>
                          )}
                        </Form.Group>
                      </div>
                    </Col>

                    {/* <Col md={4}> */}
                    {/* <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Variant MRP</Form.Label>
                          <Form.Group>
                            <Form.Control
                              type="text"
                              name={`variants.${index}.mrp`} // Register color for the variant
                              placeholder="Variant MRP"
                              className={classNames("", {
                                "is-invalid": errors?.variants?.[index]?.mrp,
                              })}
                              {...register(`variants.${index}.mrp`, {
                                required: "Variant MRP is required",
                              })}
                              onKeyDown={(e) => {
                                // Allow backspace, left and right arrow keys
                                if (
                                  e.key === "Backspace" ||
                                  e.key === "ArrowLeft" ||
                                  e.key === "ArrowRight"
                                ) {
                                  return; // Allow the action to continue
                                }

                                // Allow digits and decimal point
                                if (!/[\d.]/.test(e.key)) {
                                  e.preventDefault(); // Block the invalid key
                                }

                                // Prevent multiple decimal points
                                if (
                                  e.key === "." &&
                                  e.target.value.includes(".")
                                ) {
                                  e.preventDefault(); // Block adding another decimal point
                                }
                              }}
                            />
                            {errors?.variants?.[index]?.mrp && (
                              <span className="text-danger">
                                {errors.variants[index].mrp.message}
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div> */}


                    {/* ********************Image field start *********************** */}

                    {/* <div className="oder-detail-holder mb-3">
                        <div className="heading-holder">
                          <h6> Images  (928 × 945 px).</h6>
                        </div> */}


                    {/* <div className=""> */}
                    {/* Pickup Slot */}

                    {/* <Row className="detail-row">
                            <Col lg={4} md={4}>
                              <div className="d-flex align-items-center">

                                <Form.Control
                                  type="file"
                                   name={`variant.${index}.image`}
                                  multiple
                                  placeholder="Image"
                                  className={classNames("", {
                                    "is-invalid": errors?.image,
                                  })}
                                   {...register(`variant.${index}.image`, {
                                    // required: "Images is required",
                                  })}
                                  accept="image/*"
                                  // onChange={handleImagesChangef}
                                   onChange={(e) => handleImagesChangef(e, index)}
                                />
                              </div>
                              {errors?.features?.[index]?.image && (
                                <span className="text-danger">{errors?.features?.[index]?.image}</span>
                              )}
                            </Col>

                            <div className="img-row-holder">
                              {imagePreviewsf &&
                                imagePreviewsf.map((image, index) => {
                                  return (
                                    <div className="mt-2 mx-3" key={index}>
                                      <img
                                        src={image}
                                        alt={`Category Preview ${index}`}
                                        style={{ maxWidth: "100px" }}
                                      />
                                    </div>
                                  );
                                })}
                            </div>
                            
                          </Row> */}
                    {/*             
                        </div>                      
                      </div>
                    </Col> */}

                    {/* ********************Image field end  *********************** */}

                    <Col lg={4} md={4}>
                      <div className="oder-detail-holder mb-3">
                        <div className="heading-holder">
                          <Form.Label>Images (928 × 945 px)</Form.Label>
                        </div>

                        <Controller
                          name={`features.${index}.image`}
                          control={control}
                          rules={{
                            required: "Insert feature Image",
                          }}


                          render={({ field: { onChange } }) => (
                            <Form.Control
                              type="file"
                              accept="image/*"
                              onChange={(e) => {
                                const file = e.target.files?.[0];
                                if (file) {
                                  onChange(file);
                                  handleImagesChangef(e, index, setValue);
                                }
                              }}
                            />
                          )}
                        />

                        {errors?.features?.[index]?.image && (
                          <span className="text-danger">
                            {errors?.features?.[index]?.image.message}
                          </span>
                        )}

                        {/* PREVIEW per index */}
                        {imagePreviewsf[index] && (
                          <div className="Preview_img_holder mt-2">
                            {imagePreviewsf[index].map((preview, i) =>
                              preview.includes("video") ? (
                                <video
                                  key={i}
                                  className="Preview_video"
                                  autoPlay
                                  muted
                                  loop
                                  style={{ maxWidth: "300px" }}
                                >
                                  <source src={preview} type="video/mp4" />
                                </video>
                              ) : (
                                <img
                                  key={i}
                                  className="Preview_img"
                                  src={preview}
                                  alt="image preview"
                                  style={{ maxWidth: "300px", marginRight: "10px" }}
                                />
                              )
                            )}
                          </div>
                        )}
                      </div>
                    </Col>

                    {/* ****************img-revised*************** */}


                    {/* <Col md={4}> */}
                    {/* <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Variant Price</Form.Label>
                          <Form.Group>
                            <Form.Control
                              type="text"
                              name={`variants.${index}.price`} // Register color for the variant
                              placeholder="Variant Price"
                              className={classNames("", {
                                "is-invalid": errors?.variants?.[index]?.price,
                              })}
                              {...register(`variants.${index}.price`, {
                                required: "Variant name is required",
                                validate: {
                                  lessThanPrice: (value) => {
                                    const mrp = getValues(
                                      `variants.${index}.mrp`,
                                    );
                                    if (parseFloat(value) >= parseFloat(mrp)) {
                                      return "Price must be less than MRP";
                                    }
                                    return true;
                                  },
                                },
                              })}
                              onKeyDown={(e) => {
                                // Allow backspace, left and right arrow keys
                                if (
                                  e.key === "Backspace" ||
                                  e.key === "ArrowLeft" ||
                                  e.key === "ArrowRight"
                                ) {
                                  return; // Allow the action to continue
                                }

                                // Allow digits and decimal point
                                if (!/[\d.]/.test(e.key)) {
                                  e.preventDefault(); // Block the invalid key
                                }

                                // Prevent multiple decimal points
                                if (
                                  e.key === "." &&
                                  e.target.value.includes(".")
                                ) {
                                  e.preventDefault(); // Block adding another decimal point
                                }
                              }}
                            />
                            {errors?.variants?.[index]?.price && (
                              <span className="text-danger">
                                {errors.variants[index].price.message}
                              </span>
                            )}


                          </Form.Group>
                        </Row>

                      </div> */}
                    <Row className="detail-row">

                      <Col md={12}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>
                              Description{" "}
                              {/* <Form.Check
                          type="switch"
                          id="description_status" // Give it an id for accessibility
                          label=""
                          name="description_status"
                          checked={watch("description_status")} // Assuming you're using react-hook-form to track state
                          onChange={(e) => {
                            setValue("description_status", e.target.checked);
                          }} // Update form state on toggle
                          className={classNames("", {
                            "is-invalid": errors?.description_status,
                          })}
                        /> */}
                            </Form.Label>
                            <Form.Group>
                              <Controller
                                name={`features.${index}.description`}
                                control={control}
                                rules={{
                                  required: "description is required.",
                                  // maxLength: {
                                  //   value: 600,
                                  //   message:
                                  //     "content must be at most 600 characters long.",
                                  // },
                                }} // Correct the maxLength rule
                                render={({ field: { onChange, onBlur, value } }) => (
                                  <JoditEditor
                                    value={value}
                                    onBlur={() => {
                                      onBlur();
                                      trigger("description");
                                    }}
                                    onChange={onChange}
                                  />
                                )}
                              />
                              {errors?.features?.[index]?.description && (
                                <span className="text-danger">
                                  {errors?.features?.[index]?.description?.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>

                    </Row>
                    {/* </Col> */}
                  </Row>
                  {featureFields.length > 1 && (
                    <button
                      className="mt-3 add-varient"
                      type="button"
                      onClick={() => featureRemove(index)} // Remove the variant
                    >
                      Remove Feature
                    </button>
                  )}

                  <hr />
                </div>
              ))}
            </div>
            <hr />
            <div className="text-center">
              <button
                type="button"
                className="add-varient"
                onClick={() => featureAppend({})}
              >
                + Add Feature
              </button>
            </div>
          </div>

          {/* ******************layers start******************************************** */}

          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>Layers of Mattress</h6>
            </div>

            <input
              type="number"
              name="layer_count"
              className={`form-control w-25 ${layerCountError ? "is-invalid" : ""}`}
              placeholder="Number of Layers"
              min="0"
              max="9"
              value={layerCount === "" ? "" : layerCount}   // Use value instead of defaultValue
              onChange={(e) => handleLayerCountChange(e.target.value)}
            />
            {layerCountError && (
              <span className="text-danger" style={{ fontSize: "14px", marginTop: "5px", display: "block" }}>
                {layerCountError}
              </span>
            )}




            {layerCount > 0 && (
              <div className="package-details-section">

                {layerFields?.map((layer, index) => (
                  <div key={layer.id} className="main-form-section mt-3">
                    <Row>
                      {/* serial number field */}
                      <Col md={1}>
                        <div className="main-form-section mt-3">
                          <Form.Group>
                            <Form.Label>Sr No</Form.Label>
                            <input
                              type="text"
                              className="form-control"
                              value={index + 1}
                              disabled
                            />
                          </Form.Group>
                        </div>
                      </Col>
                      {/* NAME FIELD */}
                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Form.Group>
                            <div>
                              <Form.Label>Layer Name</Form.Label>
                            </div>

                            <Controller
                              name={`layers.${index}.name`}
                              control={control}
                              rules={{
                                required: "Name is required",
                              }}
                              render={({ field: { onChange, onBlur, value, ref } }) => (
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter layer name"
                                  onChange={(e) => onChange(e.target.value)}
                                  onBlur={onBlur}
                                  value={value || ""}
                                  ref={ref}
                                  style={{
                                    borderColor: errors?.layers?.[index]?.name
                                      ? "red"
                                      : undefined,
                                  }}
                                />
                              )}
                            />

                            {errors?.layers?.[index]?.name && (
                              <span className="text-danger">
                                {errors?.layers?.[index]?.name?.message}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                      </Col>

                      {/* DESCRIPTION FIELD */}
                      <Col md={12}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Description</Form.Label>
                            <Form.Group>
                              <Controller
                                name={`layers.${index}.description`}
                                control={control}
                                rules={{
                                  required: "Description is required.",
                                }}
                                render={({ field: { onChange, onBlur, value } }) => (
                                  <JoditEditor
                                    value={value}
                                    onBlur={() => {
                                      onBlur();
                                      trigger(`layers.${index}.description`);
                                    }}
                                    onChange={onChange}
                                  />
                                )}
                              />
                              {errors?.layers?.[index]?.description && (
                                <span className="text-danger">
                                  {errors?.layers?.[index]?.description?.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                    </Row>


                    <hr />
                  </div>
                ))}

              </div>
            )}
          </div>






          {/* ******************layers end*********************************************** */}

          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>3. Images Upload image (928 × 945 px).</h6>
            </div>

            <div className="package-details-section">
              {/* Pickup Slot */}
              <Row className="detail-row">
                <Col lg={4} md={4}>
                  <div className="d-flex align-items-center">
                    <Form.Control
                      type="file"
                      name="images"
                      multiple
                      placeholder="Image"
                      className={classNames("", {
                        "is-invalid": errors?.images,
                      })}
                      {...register("images", {
                        // required: "Images is required",
                      })}
                      accept="image/*"
                      onChange={handleImagesChange}
                    />
                  </div>
                  {errors.images && (
                    <span className="text-danger">{errors.images.message}</span>
                  )}
                </Col>
                <div className="img-row-holder">
                  {imagePreviews &&
                    imagePreviews.map((image, index) => {
                      return (
                        <div className="mt-2 mx-3" key={index}>
                          <img
                            src={image}
                            alt={`Category Preview ${index}`}
                            style={{ maxWidth: "100px" }}
                          />
                        </div>
                      );
                    })}
                </div>
              </Row>
            </div>

          </div>

          <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12">
            <Form.Label>Variant Type</Form.Label>
            <Controller
              className="select-contoller"
              name={`variant_type_id`} // name of the field
              control={control}
              rules={{
                required: "Select Variant Type",
              }}
              render={({ field: { onChange, onBlur, value, ref } }) => (
                <Select
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      borderColor: errors?.variant_type_id
                        ? "red"
                        : baseStyles.borderColor,
                    }),
                  }}
                  options={VarientType}
                  onChange={(selectedValue) => {
                    onChange(selectedValue);
                  }}
                  onBlur={onBlur}
                  value={value}
                  ref={ref}
                />
              )}
            />
            {errors.variant_type_id && (
              <span className="text-danger">
                {errors.variant_type_id.message}
              </span>
            )}
          </div>

          {Number(variantType?.value) === variant_type.Single ? (
            <div className="oder-detail-holder mb-3">
              <div className="heading-holder">
                <h6>5.{variantType?.label} Variants</h6>
              </div>

              <div className="package-details-section">
                {fields.map((variant, index) => (
                  <div key={variant.id} className="main-form-section mt-3">
                    <Row>
                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Form.Group>
                            <div className="">
                              <Form.Label>Type</Form.Label>
                            </div>

                            <Controller
                              className="select-contoller"
                              name={`variants.${index}.metal_id`}
                              // name={`variants.${index}.name`}
                              control={control}
                              rules={{
                                required: "Enter Type",
                              }}
                              render={({
                                field: { onChange, onBlur, value, ref },
                              }) => (
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Type"
                                  onChange={(e) => onChange(e.target.value)}
                                  onBlur={onBlur}
                                  value={value || ""}
                                  ref={ref}
                                  style={{
                                    borderColor: errors?.variants?.[index]
                                      ?.metal_id
                                      ? "red"
                                      : undefined,
                                  }}
                                />
                              )}
                            />

                            {errors?.variants?.[index]?.metal_id && (
                              <span className="text-danger">
                                {errors?.variants?.[index]?.metal_id.message}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                      </Col>

                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Variant MRP</Form.Label>
                            <Form.Group>
                              <Form.Control
                                type="text"
                                name={`variants.${index}.mrp`} // Register color for the variant
                                placeholder="Variant MRP"
                                className={classNames("", {
                                  "is-invalid": errors?.variants?.[index]?.mrp,
                                })}
                                {...register(`variants.${index}.mrp`, {
                                  required: "Variant MRP is required",
                                })}
                                onKeyDown={(e) => {
                                  // Allow backspace, left and right arrow keys
                                  if (
                                    e.key === "Backspace" ||
                                    e.key === "ArrowLeft" ||
                                    e.key === "ArrowRight"
                                  ) {
                                    return; // Allow the action to continue
                                  }

                                  // Allow digits and decimal point
                                  if (!/[\d.]/.test(e.key)) {
                                    e.preventDefault(); // Block the invalid key
                                  }

                                  // Prevent multiple decimal points
                                  if (
                                    e.key === "." &&
                                    e.target.value.includes(".")
                                  ) {
                                    e.preventDefault(); // Block adding another decimal point
                                  }
                                }}
                              />
                              {errors?.variants?.[index]?.mrp && (
                                <span className="text-danger">
                                  {errors.variants[index].mrp.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>

                      {/* old price code */}

                      {/* <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Variant Price</Form.Label>
                            <Form.Group>
                              <Form.Control
                                type="text"
                                name={`variants.${index}.price`} // Register color for the variant
                                placeholder="Variant Price"
                                className={classNames("", {
                                  "is-invalid":
                                    errors?.variants?.[index]?.price,
                                })}
                                {...register(`variants.${index}.price`, {
                                  required: "Variant name is required",
                                  validate: {
                                    lessThanPrice: (value) => {
                                      const mrp = getValues(
                                        `variants.${index}.mrp`,
                                      );
                                      if (
                                        parseFloat(value) >= parseFloat(mrp)
                                      ) {
                                        return "Price must be less than MRP";
                                      }
                                      return true;
                                    },
                                  },
                                })}
                                onKeyDown={(e) => {
                                  // Allow backspace, left and right arrow keys
                                  if (
                                    e.key === "Backspace" ||
                                    e.key === "ArrowLeft" ||
                                    e.key === "ArrowRight"
                                  ) {
                                    return; // Allow the action to continue
                                  }

                                  // Allow digits and decimal point
                                  if (!/[\d.]/.test(e.key)) {
                                    e.preventDefault(); // Block the invalid key
                                  }

                                  // Prevent multiple decimal points
                                  if (
                                    e.key === "." &&
                                    e.target.value.includes(".")
                                  ) {
                                    e.preventDefault(); // Block adding another decimal point
                                  }
                                }}
                              />
                              {errors?.variants?.[index]?.price && (
                                <span className="text-danger">
                                  {errors.variants[index].price.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col> */}

                      {/* old price code start  */}
                      {/* 
                      {fields.map((field, index) => (
                        <React.Fragment key={field.id}>

                          <PriceAutoCalculator
                            index={index}
                            control={control}
                            watch={watch}
                            setValue={setValue}
                            getValues={getValues}
                          />

                          <Col md={4}>
                            <div className="main-form-section mt-3">
                              <Row className="justify-content-center">
                                <Form.Label>Variant Price</Form.Label>
                                <Form.Group>

                                  <Form.Control
                                    type="text"
                                    name={`variants.${index}.price`}
                                    placeholder="Variant Price"
                                    className={classNames("", {
                                      "is-invalid": errors?.variants?.[index]?.price,
                                    })}
                                    {...register(`variants.${index}.price`)}
                                    readOnly
                                    disabled
                                  />
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>

                        </React.Fragment>
                      ))} */}
                      {/* old price code end  */}
                      <PriceAutoCalculator
                        index={index}
                        control={control}
                        setValue={setValue}
                      />

                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Variant Price</Form.Label>
                            <Form.Group>
                              <Form.Control
                                type="text"
                                name={`variants.${index}.price`}

                                placeholder="Variant Price"
                                className={classNames("", {
                                  "is-invalid": errors?.variants?.[index]?.price,
                                })}
                                {...register(`variants.${index}.price`)}
                                readOnly
                              //disabled
                              />
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                    </Row>

                    {fields.length > 1 && (
                      <button
                        className="mt-3 add-varient"
                        type="button"
                        onClick={() => remove(index)} // Remove the variant
                      >
                        Remove Variant
                      </button>
                    )}

                    <hr />
                  </div>
                ))}
              </div>
              <hr />

              <div className="text-center">
                <button
                  type="button"
                  className="add-varient"
                  onClick={() => append({})}
                >
                  + Add Variant
                </button>
              </div>
            </div>
          ) : Number(variantType?.value) === variant_type.Double ? (
            <div className="oder-detail-holder mb-3">
              <div className="heading-holder">
                <h6>5.{variantType?.label} Variants</h6>
              </div>

              <div className="package-details-section">
                {fields.map((variant, index) => (
                  <div key={variant.id} className="main-form-section mt-3">
                    <Row>
                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Form.Group>
                            <div className="">
                              <Form.Label>Type</Form.Label>
                            </div>

                            <Controller
                              className="select-contoller"
                              name={`variants.${index}.metal_id`}
                              control={control}
                              rules={{
                                required: "Enter Type",
                              }}
                              render={({
                                field: { onChange, onBlur, value, ref },
                              }) => (
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Type`"
                                  onChange={(e) => onChange(e.target.value)}
                                  onBlur={onBlur}
                                  value={value || ""}
                                  ref={ref}
                                  style={{
                                    borderColor: errors?.variants?.[index]
                                      ?.metal_id
                                      ? "red"
                                      : undefined,
                                  }}
                                />
                              )}
                            />

                            {errors?.variants?.[index]?.metal_id && (
                              <span className="text-danger">
                                {errors?.variants?.[index]?.metal_id.message}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                      </Col>
                      <DoubleVarient
                        useWatch={useWatch}
                        clearErrors={clearErrors}
                        setError={setError}
                        product_id={getValues(`variants.${index}.product_id`)}
                        singleIndex={index}
                        control={control}
                        variantType={variantType}
                        register={register}
                        getValues={getValues}
                        errors={errors}
                        setValue={setValue}
                      />
                    </Row>
                    {fields.length > 1 && (
                      <button
                        className="mt-3 add-varient"
                        type="button"
                        onClick={() => remove(index)} // Remove the variant
                      >
                        Remove Variant
                      </button>
                    )}
                    <hr />
                  </div>
                ))}
              </div>
              <hr />
              <div className="text-center">
                <button
                  type="button"
                  className="add-varient"
                  onClick={() => append({})}
                >
                  + Add Variant
                </button>
              </div>
            </div>
          ) : Number(variantType?.value) === variant_type.Triple ? (
            <div className="oder-detail-holder mb-3">
              <div className="heading-holder">
                <h6>5.{variantType?.label} Variants</h6>
              </div>

              <div className="package-details-section">
                {fields.map((variant, index) => (
                  <div key={variant.id} className="main-form-section mt-3">
                    <Row>
                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Form.Group>
                            <div className="">
                              <Form.Label>Type</Form.Label>
                            </div>

                            <Controller
                              className="select-contoller"
                              name={`variants.${index}.metal_id`}
                              control={control}
                              rules={{
                                required: "Enter Type",
                              }}
                              render={({
                                field: { onChange, onBlur, value, ref },
                              }) => (
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Type"
                                  onChange={(e) => onChange(e.target.value)}
                                  onBlur={onBlur}
                                  value={value || ""}
                                  ref={ref}
                                  style={{
                                    borderColor: errors?.variants?.[index]
                                      ?.metal_id
                                      ? "red"
                                      : undefined,
                                  }}
                                />
                              )}
                            />

                            {errors?.variants?.[index]?.metal_id && (
                              <span className="text-danger">
                                {errors?.variants?.[index]?.metal_id.message}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                      </Col>

                      <DoubleVarient
                        useWatch={useWatch}
                        clearErrors={clearErrors}
                        setError={setError}
                        variantType={variantType}
                        singleIndex={index}
                        control={control}
                        register={register}
                        getValues={getValues}
                        errors={errors}
                        setValue={setValue}
                      />
                    </Row>
                    {fields.length > 1 && (
                      <button
                        className="mt-3 add-varient"
                        type="button"
                        onClick={() => remove(index)} // Remove the variant
                      >
                        Remove Variant
                      </button>
                    )}
                    <hr />
                  </div>
                ))}
              </div>
              <hr />
              <div className="text-center">
                <button
                  type="button"
                  className="add-varient"
                  onClick={() => append({})}
                >
                  + Add Variant
                </button>
              </div>
            </div>
          ) : null}

          <div className="d-flex justify-content-center">
            <div className="text-center mt-4 mx-2">
              <button
                className="Back-button"
                type="submit"
                disabled={isLoading}
                onClick={() => navigate("/products")}
              >
                {" "}
                Cancel
              </button>
            </div>

            <div className="text-center mt-4 mx-2">
              <button
                className="schedule-button"
                type="submit"
                disabled={isLoading}
              //onClick={onSubmit}
              >
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Creating...
                  </>
                ) : (
                  'Create Product'
                )}
              </button>
            </div>
          </div>
        </Form>
        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />
      </section >
    </>
  );
}

export default Create;
